import React, {h, Component} from 'preact';

export default class BuyCreditScoreStep extends Component {
    static CREDIT_SCORES = {
        'Excellent (740 and above)': '740 and above',
        'Great (700 to 739)': '700 to 739',
        'Average (660 to 699)': '660 to 699',
        'Below Average (620 to 659)': '620 to 659',
        'Poor (below 619)': 'Below 619',
        '': 'Not Sure'
    };

    componentDidMount() {
        trackEvent('Flow', 'BuyRequest', 'buyStep4').withGA().withOptimizely();
        trackEvent('Flow', 'BuyRequest', 'buyerLoadedStep5').withGA().withOptimizely();
        trackEvent('Flow', 'BuyRequest', 'buyStepCreditScore').withGA().withOptimizely();
    }

    chooseCreditScore(creditScore) {
        trackEvent('Flow', 'BuyRequest', 'buyerChoseCreditScore', {creditScore}).withGA();

        $.get('update-buyrequest-json', {
            buyerStage: this.props.parent.state.buyerStage,
            propertyType: this.props.parent.state.homeType,
            priceRange: this.props.parent.state.lowRange + '-' + this.props.parent.state.highRange
        });
        this.props.parent.setState({creditScore, currentStep: 'BUY_CONTACT_FORM'});
    }

    render() {
        return <div className="flow-step">
            {/*TODO:: Remove UHL*/}
            {/*{homeLoansEnabled && (*/}
            {/*    <div className="flow-step-text hidden-xs">*/}
            {/*        <img className="icon-desktop" src={global.imageBaseUrl + '/buysell/svg/save-with-upnest.svg'} />*/}
            {/*        <div>Unlock more savings with UpNest Home Loans.</div>*/}
            {/*    </div>*/}
            {/*)}*/}

            <div className="flow-step-header-text">
                <strong>What&apos;s your credit score?</strong>
            </div>

            <div className="option-div">
                <div id="buyer-credit-score-div">
                    {$.map(BuyCreditScoreStep.CREDIT_SCORES, (value, key) => {
                        return <div onClick={() => this.chooseCreditScore(key)} className="choice-button credit-score-button">
                            <span className="button-text">{value}</span>
                        </div>;
                    })}
                </div>
            </div>

            {/*TODO:: Remove UHL*/}
            {/*<div className="flow-spacer"/>*/}

            {/*<div className="bottom-banner">*/}
            {/*    <div className="status-normal">*/}
            {/*        <div className="title"><img src={global.imageBaseUrl + '/buysell/svg/save-with-upnest.svg'}/> Save More Money</div>*/}
            {/*        <div className="subtitle subtitle-large">Unlock more savings with UpNest Home Loans.</div>*/}
            {/*    </div>*/}
            {/*    <div className="subtitle subtitle subtitle-small">*/}
            {/*        Unlock more savings with UpNest Home Loans.*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>;
    }
}
